interface FilterBarProps {
  selectedRegion: string;
  setSelectedRegion: (region: string) => void;
  selectedState: string;
  setSelectedState: (state: string) => void;
  selectedUnion: string;
  setSelectedUnion: (union: string) => void;
  selectedConference: string;
  setSelectedConference: (conference: string) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export default function FilterBar({
  selectedRegion,
  setSelectedRegion,
  selectedState,
  setSelectedState,
  selectedUnion,
  setSelectedUnion,
  selectedConference,
  setSelectedConference,
}: FilterBarProps) {
  const regions = ['All', 'South West', 'South East', 'South South', 'North Central', 'North West', 'North East'];
  
  // Get unions based on selected region
  const getUnionsByRegion = () => {
    if (selectedRegion === 'All' || selectedRegion === '') {
      return [
        'All',
        'Eastern Nigeria Union Conference (ENUC)',
        'Northern Nigeria Union Conference (NNUC)',
        'Western Nigeria Union Conference (WNUC)'
      ];
    }

    if (selectedRegion === 'South East' || selectedRegion === 'South South') {
      return ['All', 'Eastern Nigeria Union Conference (ENUC)'];
    }

    if (selectedRegion === 'North Central' || selectedRegion === 'North West' || selectedRegion === 'North East') {
      return ['All', 'Northern Nigeria Union Conference (NNUC)'];
    }

    if (selectedRegion === 'South West') {
      return ['All', 'Western Nigeria Union Conference (WNUC)'];
    }

    return ['All'];
  };

  // Get states based on selected region
  const getStatesByRegion = () => {
    if (selectedRegion === 'All' || selectedRegion === '') {
      return [
        'All',
        'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno',
        'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo',
        'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa',
        'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba',
        'Yobe', 'Zamfara'
      ];
    }

    if (selectedRegion === 'South West') {
      return ['All', 'Ekiti', 'Lagos', 'Ogun', 'Ondo', 'Osun', 'Oyo'];
    }

    if (selectedRegion === 'South East') {
      return ['All', 'Abia', 'Anambra', 'Ebonyi', 'Enugu', 'Imo'];
    }

    if (selectedRegion === 'South South') {
      return ['All', 'Akwa Ibom', 'Bayelsa', 'Cross River', 'Delta', 'Edo', 'Rivers'];
    }

    if (selectedRegion === 'North Central') {
      return ['All', 'Benue', 'FCT', 'Kogi', 'Kwara', 'Nasarawa', 'Niger', 'Plateau'];
    }

    if (selectedRegion === 'North West') {
      return ['All', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Sokoto', 'Zamfara'];
    }

    if (selectedRegion === 'North East') {
      return ['All', 'Adamawa', 'Bauchi', 'Borno', 'Gombe', 'Taraba', 'Yobe'];
    }

    return ['All'];
  };

  // Get conferences based on selected state
  const getConferencesByState = () => {
    if (selectedState === 'All' || selectedState === '') {
      return [
        'All',
        // ENUC
        'Aba East Conference', 'Aba North Conference', 'Aba South Conference', 'Abia North-Central Conference',
        'Abonyi Conference', 'Akwa Ibom Conference', 'Anambra Mission', 'Bayelsa Mission',
        'Cross River Conference', 'Enugu Conference', 'Imo Conference', 'Port Harcourt Conference',
        'Rivers East Conference', 'Rivers West Conference',
        // NNUC
        'Abuja Conference', 'Adamawa Mission', 'Bauchi Conference', 'Benue Conference',
        'Borno Mission', 'Gombe Conference', 'North Central Nigeria Conference', 'North-East Nigeria Conference',
        'North-West Nigeria Conference', 'Plateau Conference', 'Taraba Mission',
        // WNUC
        'Edo-Delta Conference', 'Ekiti Mission', 'Kogi Mission', 'Kwara Mission',
        'Lagos Atlantic Conference', 'Lagos Mainland Conference', 'Ogun Conference', 'Ondo Mission',
        'Osun Mission', 'Oyo Conference'
      ];
    }

    // ENUC States
    if (selectedState === 'Abia') {
      return ['All', 'Aba East Conference', 'Aba North Conference', 'Aba South Conference', 'Abia North-Central Conference'];
    }
    if (selectedState === 'Ebonyi') {
      return ['All', 'Abonyi Conference'];
    }
    if (selectedState === 'Akwa Ibom') {
      return ['All', 'Akwa Ibom Conference'];
    }
    if (selectedState === 'Anambra') {
      return ['All', 'Anambra Mission'];
    }
    if (selectedState === 'Bayelsa') {
      return ['All', 'Bayelsa Mission'];
    }
    if (selectedState === 'Cross River') {
      return ['All', 'Cross River Conference'];
    }
    if (selectedState === 'Enugu') {
      return ['All', 'Enugu Conference'];
    }
    if (selectedState === 'Imo') {
      return ['All', 'Imo Conference'];
    }
    if (selectedState === 'Rivers') {
      return ['All', 'Port Harcourt Conference', 'Rivers East Conference', 'Rivers West Conference'];
    }

    // NNUC States
    if (selectedState === 'FCT') {
      return ['All', 'Abuja Conference'];
    }
    if (selectedState === 'Adamawa') {
      return ['All', 'Adamawa Mission'];
    }
    if (selectedState === 'Bauchi') {
      return ['All', 'Bauchi Conference'];
    }
    if (selectedState === 'Benue') {
      return ['All', 'Benue Conference'];
    }
    if (selectedState === 'Borno') {
      return ['All', 'Borno Mission'];
    }
    if (selectedState === 'Gombe') {
      return ['All', 'Gombe Conference'];
    }
    if (selectedState === 'Nasarawa' || selectedState === 'Niger') {
      return ['All', 'North Central Nigeria Conference'];
    }
    if (selectedState === 'Yobe') {
      return ['All', 'North-East Nigeria Conference'];
    }
    if (selectedState === 'Jigawa' || selectedState === 'Kano' || selectedState === 'Katsina' || selectedState === 'Kebbi' || selectedState === 'Sokoto' || selectedState === 'Zamfara') {
      return ['All', 'North-West Nigeria Conference'];
    }
    if (selectedState === 'Plateau') {
      return ['All', 'Plateau Conference'];
    }
    if (selectedState === 'Taraba') {
      return ['All', 'Taraba Mission'];
    }

    // WNUC States
    if (selectedState === 'Edo' || selectedState === 'Delta') {
      return ['All', 'Edo-Delta Conference'];
    }
    if (selectedState === 'Ekiti') {
      return ['All', 'Ekiti Mission'];
    }
    if (selectedState === 'Kogi') {
      return ['All', 'Kogi Mission'];
    }
    if (selectedState === 'Kwara') {
      return ['All', 'Kwara Mission'];
    }
    if (selectedState === 'Lagos') {
      return ['All', 'Lagos Atlantic Conference', 'Lagos Mainland Conference'];
    }
    if (selectedState === 'Ogun') {
      return ['All', 'Ogun Conference'];
    }
    if (selectedState === 'Ondo') {
      return ['All', 'Ondo Mission'];
    }
    if (selectedState === 'Osun') {
      return ['All', 'Osun Mission'];
    }
    if (selectedState === 'Oyo') {
      return ['All', 'Oyo Conference'];
    }

    return ['All'];
  };

  const unions = getUnionsByRegion();
  const states = getStatesByRegion();
  const conferences = getConferencesByState();

  return (
    <div className="bg-white rounded-xl shadow-md p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-700 flex items-center">
          <i className="ri-filter-3-line mr-2 text-emerald-600"></i>
          Refine Results
        </h3>
        <span className="text-xs text-gray-500">Optional filters to narrow your search</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Region</label>
          <select
            value={selectedRegion}
            onChange={(e) => {
              setSelectedRegion(e.target.value);
              setSelectedUnion('All');
              setSelectedState('All');
              setSelectedConference('All');
            }}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent cursor-pointer"
          >
            {regions.map(region => (
              <option key={region} value={region}>{region}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Union</label>
          <select
            value={selectedUnion}
            onChange={(e) => {
              setSelectedUnion(e.target.value);
            }}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent cursor-pointer"
          >
            {unions.map(union => (
              <option key={union} value={union}>{union}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">State</label>
          <select
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setSelectedConference('All');
            }}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent cursor-pointer"
          >
            {states.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Conference</label>
          <select
            value={selectedConference}
            onChange={(e) => setSelectedConference(e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent cursor-pointer"
          >
            {conferences.map(conference => (
              <option key={conference} value={conference}>{conference}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
